import React from "react";
import Reports from "./components/Reports";

function App() {
  return (
    <div>
      <Reports />
    </div>
  );
}

export default App;
